import {shareReplay, distinctUntilChanged, mergeMap, map} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {APPCONFIG} from '../../config';
import {BehaviorSubject, Observable} from 'rxjs';
import {User} from '../../cache/currentuser/user';
import {CacheService} from '../../cache/cache.service';
import {ResourceService} from '../../resource/resource.service';
import {Router} from '@angular/router';
import {LayoutService} from '../layout.service';

@Component({
  selector: 'my-app-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppFooterComponent implements OnInit {
  public AppConfig: any;
  private administratorAccess: Observable<boolean>;

  public year = new Date().getFullYear();
  constructor(
    private changeDetector: ChangeDetectorRef,
    private cacheService: CacheService,
    private router: Router,
    private layoutService: LayoutService,
    private ngZone: NgZone,
  ) {
    this.administratorAccess = this.cacheService.getCurrentUser().pipe(
      map((usr: User) => usr.administrator),
      mergeMap(bool => bool),
      distinctUntilChanged(),
      shareReplay(1),
    );
  }
  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.changeDetector.markForCheck();
  }

  onUpdateRoutine(): void {
    this.administratorAccess.subscribe(bool => {
      if (bool) {
        // navigate to admin/configuration
        this.ngZone.runOutsideAngular(() => {
          let link = ['/admin/configuration'];
          this.ngZone.run(() => {
            this.router.navigate(link);
          });
        });
      }
    });
  }
}
